/**
 * @generated SignedSource<<854830e4616d4a17d8944a847bba580a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InlineContentDrawerTemplateQuery$variables = {
  id: string;
};
export type InlineContentDrawerTemplateQuery$data = {
  readonly contentUsage: {
    readonly " $fragmentSpreads": FragmentRefs<"InlineContentDrawerTemplateFragment">;
  } | null;
};
export type InlineContentDrawerTemplateQuery = {
  response: InlineContentDrawerTemplateQuery$data;
  variables: InlineContentDrawerTemplateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPrerequisites",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entity",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordering",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueAt",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enabled",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "required",
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showComments",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passPercentage",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemTaskKind",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "richEditorDescriptionContent",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverVideo",
  "storageKey": null
},
v20 = [
  (v2/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCoverPlayIcon",
  "storageKey": null
},
v22 = [
  (v17/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentLabelId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v25 = [
  (v2/*: any*/),
  (v12/*: any*/)
],
v26 = [
  (v12/*: any*/),
  (v2/*: any*/)
],
v27 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasViewerBookmarked",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurriculumModule",
  "storageKey": null
},
v30 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ContentUsageNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ContentUsage",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v20/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releasedAt",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creationDatetime",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCollectionModule",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasCompleted",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v37 = [
  (v36/*: any*/)
],
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v39 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v36/*: any*/),
  (v38/*: any*/)
],
v40 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v36/*: any*/),
  (v38/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InlineContentDrawerTemplateQuery",
    "selections": [
      {
        "alias": "contentUsage",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "InlineContentDrawerTemplateFragment"
              }
            ],
            "type": "ContentUsage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InlineContentDrawerTemplateQuery",
    "selections": [
      {
        "alias": "contentUsage",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "submissionMethod",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "submissionVisibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignmentSubmissionFormat",
                "kind": "LinkedField",
                "name": "submissionFormat",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssignmentSubmissionFormatSettings",
                    "kind": "LinkedField",
                    "name": "text",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssignmentSubmissionFormatSettings",
                    "kind": "LinkedField",
                    "name": "file",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssignmentSubmissionFormatSettings",
                    "kind": "LinkedField",
                    "name": "link",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requireScormCompletion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentAttachmentNodeConnection",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentAttachmentNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentAttachment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mediaUrl",
                                "storageKey": null
                              },
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "downloadUrl",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "videoUrl",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "coverPhoto",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeEstimateMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "coverVideoAsset",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "coverVideoDurationSeconds",
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "usages",
                    "plural": false,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WebForm",
                    "kind": "LinkedField",
                    "name": "webForm",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebFormRevision",
                        "kind": "LinkedField",
                        "name": "currentRevision",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "webFormId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WebFormQuestionNodeConnection",
                            "kind": "LinkedField",
                            "name": "questions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormQuestionNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WebFormQuestion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v13/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "richEditorBody",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isRequired",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "WebFormQuestionOption",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": true,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v14/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "WebFormQuestionAnswerKey",
                                        "kind": "LinkedField",
                                        "name": "answerKey",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "correctIds",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "feedback",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssetUsage",
                    "kind": "LinkedField",
                    "name": "coverVideoAssetUsage",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentMentionNodeConnection",
                    "kind": "LinkedField",
                    "name": "mentions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentMentionNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentMention",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "fullName",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberGroup",
                                "kind": "LinkedField",
                                "name": "memberGroup",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v12/*: any*/),
                                  (v24/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "role",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "mentionedProduct",
                                "plural": false,
                                "selections": (v25/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsage",
                                "kind": "LinkedField",
                                "name": "mentionedContentUsage",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": (v25/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Occurrence",
                                "kind": "LinkedField",
                                "name": "mentionedOccurrence",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": (v26/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasUnprocessedMediaAssets",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasProcessedMediaAssets",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "last",
                        "value": 3
                      }
                    ],
                    "concreteType": "BrainSearchRelatedQuestionNodeConnection",
                    "kind": "LinkedField",
                    "name": "brainSearchRelatedQuestions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrainSearchRelatedQuestionNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrainSearchRelatedQuestion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BrainSearch",
                                "kind": "LinkedField",
                                "name": "viewerBrainSearch",
                                "plural": false,
                                "selections": (v20/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BrainSearchMessage",
                                "kind": "LinkedField",
                                "name": "viewerBrainSearchMessage",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "brainSearchId",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "brainSearchRelatedQuestions(last:3)"
                  },
                  (v29/*: any*/),
                  {
                    "alias": "allChildren",
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": (v30/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentUsageNodeConnection",
                "kind": "LinkedField",
                "name": "prerequisites",
                "plural": false,
                "selections": (v30/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adminCanLearnMode",
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v31/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductMembership",
                    "kind": "LinkedField",
                    "name": "viewerMembership",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductApp",
                "kind": "LinkedField",
                "name": "productApp",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customAppTitle",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "module",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "usages",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v32/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isReleased",
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v12/*: any*/),
                                  (v29/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": (v22/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v13/*: any*/),
                                  (v12/*: any*/),
                                  (v15/*: any*/),
                                  (v14/*: any*/),
                                  (v33/*: any*/),
                                  (v19/*: any*/),
                                  (v18/*: any*/),
                                  (v21/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v34/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentDashboardBlock",
                "kind": "LinkedField",
                "name": "contentDashboardBlock",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "confirmationModalContent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ctaText",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "productId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentUsageNodeConnection",
                "kind": "LinkedField",
                "name": "dependents",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              (v2/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v12/*: any*/),
                              (v33/*: any*/),
                              (v19/*: any*/),
                              (v18/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "description",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsageNodeConnection",
                                "kind": "LinkedField",
                                "name": "children",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsage",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v35/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              (v23/*: any*/),
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v32/*: any*/),
                          (v35/*: any*/),
                          (v8/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "module",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              (v34/*: any*/),
                              (v12/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v11/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contentId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentLikeNodeConnection",
                "kind": "LinkedField",
                "name": "likes",
                "plural": false,
                "selections": (v22/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentReactionConnection",
                "kind": "LinkedField",
                "name": "uniqueReactions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentReactionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentReaction",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasViewerReacted",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emojiCode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emojiAlias",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emojiCount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalComments",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasViewerCommented",
                "storageKey": null
              },
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ScormCompletion",
                "kind": "LinkedField",
                "name": "viewerScormCompletion",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignmentSubmission",
                "kind": "LinkedField",
                "name": "viewerSubmission",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPassed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": (v37/*: any*/),
                    "type": "Organization",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "nonNullProductId",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      (v36/*: any*/),
                      (v38/*: any*/)
                    ],
                    "type": "Product",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v39/*: any*/),
                    "type": "Event",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v40/*: any*/),
                    "type": "Comment",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v40/*: any*/),
                    "type": "Feed",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v40/*: any*/),
                    "type": "Post",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "nullableProductIdString",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productId",
                        "storageKey": null
                      },
                      (v36/*: any*/),
                      (v38/*: any*/)
                    ],
                    "type": "ContentUsage",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v40/*: any*/),
                    "type": "ChatChannel",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v40/*: any*/),
                    "type": "Dashboard",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v39/*: any*/),
                    "type": "AssignmentSubmission",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v37/*: any*/),
                    "type": "PathwayGroup",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v37/*: any*/),
                    "type": "BrainSearch",
                    "abstractKey": null
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "type": "ContentUsage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b68d0a33a55c2c60d79e9dc9dffb130e",
    "id": null,
    "metadata": {},
    "name": "InlineContentDrawerTemplateQuery",
    "operationKind": "query",
    "text": "query InlineContentDrawerTemplateQuery(\n  $id: ID!\n) {\n  contentUsage: node(id: $id) {\n    __typename\n    ... on ContentUsage {\n      ...InlineContentDrawerTemplateFragment\n    }\n    id\n  }\n}\n\nfragment AdminContentLibraryItemUsages_ContentFragment on Content {\n  id\n}\n\nfragment BookmarkButtonContentFragment on Content {\n  id\n  hasViewerBookmarked\n}\n\nfragment BookmarkButtonContentUsageFragment on ContentUsage {\n  id\n  hasViewerBookmarked\n}\n\nfragment CommentUtils_useTotalCommentsOnUsageCount on ContentUsage {\n  totalComments\n}\n\nfragment ConnectSlackCurriculumItemBannerFragment on ContentUsage {\n  viewerHasCompleted\n}\n\nfragment ContentCommentButton_ContentUsageFragment on ContentUsage {\n  ...CommentUtils_useTotalCommentsOnUsageCount\n  hasViewerCommented\n}\n\nfragment ContentFooterSection_ContentUsageFragment on ContentUsage {\n  id\n  contentId\n  hasViewerBookmarked\n  showComments\n  ...ContentReactionButton_ContentUsageFragment\n  ...ContentCommentButton_ContentUsageFragment\n  ...BookmarkButtonContentUsageFragment\n}\n\nfragment ContentInstancesTooltipFragment on Content {\n  usages {\n    totalCount\n  }\n  ...AdminContentLibraryItemUsages_ContentFragment\n}\n\nfragment ContentReactionButton_ContentUsageFragment on ContentUsage {\n  id\n  likes {\n    totalCount\n  }\n  uniqueReactions {\n    edges {\n      node {\n        id\n        hasViewerReacted\n        emojiCode\n        emojiAlias\n        emojiCount\n      }\n    }\n  }\n}\n\nfragment ContentSuggestedPromptListItemQuestion on BrainSearchRelatedQuestion {\n  id\n  text\n  viewerBrainSearch {\n    id\n  }\n  viewerBrainSearchMessage {\n    id\n    brainSearchId\n  }\n}\n\nfragment ContentSuggestedPromptsListContentFragment on Content {\n  id\n  richEditorDescriptionContent\n  hasUnprocessedMediaAssets\n  hasProcessedMediaAssets\n  brainSearchRelatedQuestions(last: 3) {\n    edges {\n      node {\n        id\n        ...ContentSuggestedPromptListItemQuestion\n      }\n    }\n  }\n}\n\nfragment ContentThumbnailWithDetails_ContentFragment on Content {\n  id\n  type\n  label\n  name\n  creationDatetime\n  ...ContentThumbnail_ContentFragment\n}\n\nfragment ContentThumbnailWithDetails_ContentUsageFragment on ContentUsage {\n  id\n  dueAt\n  entity\n  product {\n    name\n    id\n  }\n  module {\n    isCurriculumModule\n    isCollectionModule\n    name\n    id\n  }\n}\n\nfragment ContentThumbnail_ContentFragment on Content {\n  id\n  type\n  coverVideo\n  thumbnailUrl\n  showCoverPlayIcon\n}\n\nfragment ContentUsageAssignmentSubmitBannerFragment on ContentUsage {\n  id\n  submissionMethod\n  passPercentage\n  viewerSubmission {\n    id\n    hasPassed\n  }\n  ...ContentUsageUtils_useSubmissionDeadlineFragment\n  ...SubmitAssignmentFormFragment\n}\n\nfragment ContentUsageBrainSearchButtonFragment on ContentUsage {\n  id\n  content {\n    type\n    id\n  }\n}\n\nfragment ContentUsageMarkAsCompleteButtonFragment on ContentUsage {\n  id\n  ...useTrackContentCompletionFragment\n  viewerScormCompletion {\n    status\n    id\n  }\n  requireScormCompletion\n  confirmationModalContent {\n    ...CurriculumConfirmationModalConfirmationModalFragment\n    id\n  }\n  ...usePermissionsFragment\n}\n\nfragment ContentUsagePrerequisiteItemFragment on ContentUsage {\n  id\n  releasedAt\n  viewerHasCompleted\n  ...ContentThumbnailWithDetails_ContentUsageFragment\n  isLocked\n  passPercentage\n  content {\n    id\n    isCurriculumModule\n    ...ContentThumbnailWithDetails_ContentFragment\n    name\n    type\n    description\n    children {\n      totalCount\n      edges {\n        node {\n          id\n          viewerHasCompleted\n          content {\n            type\n            contentLabelId\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ContentUsageUtils_UseParentEntityContentUsageFragment on ContentUsage {\n  id\n  entity\n  module {\n    isCurriculumModule\n    isCollectionModule\n    id\n  }\n  productApp {\n    kind\n    id\n  }\n}\n\nfragment ContentUsageUtils_useContentUsagePathContentUsageFragment on ContentUsage {\n  id\n  entity\n  entityId\n  product {\n    slug\n    id\n  }\n  productApp {\n    kind\n    id\n  }\n  module {\n    usages {\n      edges {\n        node {\n          id\n          entity\n          entityId\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ContentUsageUtils_useNavigateToNextContentUsageFragment on ContentUsage {\n  id\n  module {\n    children {\n      edges {\n        node {\n          id\n          content {\n            id\n            type\n            name\n            systemTaskKind\n            ...ContentThumbnailWithDetails_ContentFragment\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ContentUsageUtils_useSubmissionDeadlineFragment on ContentUsage {\n  dueAt\n  viewerSubmission {\n    createdAt\n    id\n  }\n}\n\nfragment CopyContentUsageLinkButtonFragment on ContentUsage {\n  id\n  entity\n  module {\n    id\n  }\n  content {\n    label\n    id\n  }\n  ...ShareContentUsageUtils_useShareUrlFragment\n}\n\nfragment CurriculumConfirmationModalConfirmationModalFragment on Content {\n  name\n  richEditorDescriptionContent\n  ctaText\n}\n\nfragment CurriculumDrawerFooterContentFragment on ContentUsage {\n  id\n  viewerHasCompleted\n  content {\n    type\n    systemTaskKind\n    id\n  }\n  isLocked\n  submissionMethod\n  ...usePermissionsFragment\n  ...ContentUsageMarkAsCompleteButtonFragment\n}\n\nfragment DeleteContentUsageButtonFragment on ContentUsage {\n  id\n  isLocked\n  entity\n  entityId\n  productId\n  dependents {\n    edges {\n      node {\n        id\n        content {\n          isCurriculumModule\n          id\n        }\n        ...ContentUsagePrerequisiteItemFragment\n        ...UpdateContentModuleButtonFragment\n      }\n    }\n  }\n  module {\n    isCurriculumModule\n    id\n  }\n  content {\n    type\n    label\n    isCurriculumModule\n    allChildren: children {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    id\n  }\n  productApp {\n    customAppTitle\n    id\n  }\n  ...ContentUsageUtils_useNavigateToNextContentUsageFragment\n  ...ContentUsageUtils_UseParentEntityContentUsageFragment\n}\n\nfragment DiscoEditorMentionsFragment on Content {\n  id\n  ...EditorMentionsProviderFragment\n}\n\nfragment EditorMentionsProviderFragment on Content {\n  id\n  mentions {\n    edges {\n      node {\n        id\n        user {\n          id\n          fullName\n        }\n        memberGroup {\n          id\n          name\n          kind\n          role\n        }\n        mentionedProduct {\n          id\n          name\n        }\n        mentionedContentUsage {\n          id\n          content {\n            id\n            name\n          }\n        }\n        mentionedOccurrence {\n          id\n          name\n          content {\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment InlineContentAttachmentsSectionFragment on Content {\n  attachments {\n    edges {\n      node {\n        id\n        name\n        type\n        downloadUrl\n        videoUrl\n        mediaUrl\n      }\n    }\n  }\n}\n\nfragment InlineContentCoverVideoFormFragment on Content {\n  coverVideoAsset {\n    id\n  }\n}\n\nfragment InlineContentDescriptionSectionFragment on Content {\n  id\n  richEditorDescriptionContent\n  ...DiscoEditorMentionsFragment\n}\n\nfragment InlineContentDrawerFooterFragment on ContentUsage {\n  content {\n    usages {\n      totalCount\n    }\n    ...ContentInstancesTooltipFragment\n    id\n  }\n  ...CurriculumDrawerFooterContentFragment\n  ...InlineContentDrawerSubmitButtonFragment\n}\n\nfragment InlineContentDrawerHeaderOverflowFragment on ContentUsage {\n  ...DeleteContentUsageButtonFragment\n  ...usePermissionsFragment\n  ...CopyContentUsageLinkButtonFragment\n  ...ShareContentUsageByEmailButtonFragment\n  ...BookmarkButtonContentUsageFragment\n  content {\n    hasViewerBookmarked\n    ...BookmarkButtonContentFragment\n    id\n  }\n}\n\nfragment InlineContentDrawerSubmitButtonFragment on ContentUsage {\n  entity\n  content {\n    type\n    label\n    contentLabelId\n    usages {\n      totalCount\n    }\n    id\n  }\n}\n\nfragment InlineContentDrawerTemplateFragment on ContentUsage {\n  id\n  isLocked\n  hasPrerequisites\n  entity\n  entityId\n  ordering\n  dueAt\n  submissionMethod\n  submissionVisibility\n  submissionFormat {\n    text {\n      enabled\n      required\n    }\n    file {\n      enabled\n      required\n    }\n    link {\n      enabled\n      required\n    }\n  }\n  showComments\n  passPercentage\n  requireScormCompletion\n  content {\n    id\n    name\n    type\n    label\n    systemTaskKind\n    richEditorDescriptionContent\n    attachments {\n      edges {\n        node {\n          id\n          name\n          mediaUrl\n        }\n      }\n    }\n    thumbnailUrl\n    coverPhoto\n    coverVideo\n    timeEstimateMinutes\n    coverVideoAsset {\n      id\n    }\n    coverVideoDurationSeconds\n    showCoverPlayIcon\n    usages {\n      totalCount\n    }\n    contentLabelId\n    webForm {\n      id\n      currentRevision {\n        id\n        webFormId\n        questions {\n          edges {\n            node {\n              id\n              type\n              ordering\n              richEditorBody\n              isRequired\n              options {\n                id\n                label\n              }\n              answerKey {\n                correctIds\n                feedback\n              }\n            }\n          }\n        }\n      }\n    }\n    ...InlineContentHeroSectionFragment\n    ...InlineContentAttachmentsSectionFragment\n    ...InlineContentDescriptionSectionFragment\n    ...InlineContentHeroAndProperties_ContentFragment\n    ...BookmarkButtonContentFragment\n    ...DiscoEditorMentionsFragment\n    ...ContentSuggestedPromptsListContentFragment\n  }\n  prerequisites {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  product {\n    id\n    adminCanLearnMode\n    ...LearnModeSwitchFragment\n  }\n  productApp {\n    id\n    kind\n  }\n  module {\n    name\n    usages {\n      edges {\n        node {\n          id\n          ...InlineContentDrawerTemplate_ModuleContentUsageFragment\n        }\n      }\n    }\n    id\n  }\n  contentDashboardBlock {\n    id\n  }\n  confirmationModalContent {\n    id\n    name\n    richEditorDescriptionContent\n    ctaText\n  }\n  ...QuizSubmissionEditorContentUsageFragment\n  ...InlineContentDrawerTitleFormFragment\n  ...InlineContentDrawerHeaderOverflowFragment\n  ...ContentFooterSection_ContentUsageFragment\n  ...InlineContentDrawerFooterFragment\n  ...usePermissionsFragment\n  ...useTrackContentViewFragment\n  ...QuizEditorBanner_ContentUsageFragment\n  ...ContentUsageAssignmentSubmitBannerFragment\n  ...ConnectSlackCurriculumItemBannerFragment\n  ...BookmarkButtonContentUsageFragment\n  ...ContentUsageBrainSearchButtonFragment\n}\n\nfragment InlineContentDrawerTemplate_ModuleContentUsageFragment on ContentUsage {\n  id\n  entity\n  entityId\n  releasedAt\n  isReleased\n  isLocked\n  hasPrerequisites\n  content {\n    id\n    name\n    isCurriculumModule\n    children {\n      totalCount\n    }\n  }\n}\n\nfragment InlineContentDrawerTitleFormFragment on ContentUsage {\n  id\n  content {\n    name\n    id\n  }\n  ...InlineContentDrawerSubmitButtonFragment\n}\n\nfragment InlineContentHeroAndProperties_ContentFragment on Content {\n  id\n  name\n  type\n  attachments {\n    edges {\n      node {\n        id\n        name\n        mediaUrl\n      }\n    }\n  }\n  thumbnailUrl\n  coverPhoto\n  coverVideo\n  coverVideoDurationSeconds\n  showComments\n  showCoverPlayIcon\n  ...InlineContentHeroSectionFragment\n  ...InlineContentAttachmentsSectionFragment\n  ...InlineContentHeroButtonsFragment\n}\n\nfragment InlineContentHeroButtonsFragment on Content {\n  attachments {\n    totalCount\n  }\n  coverPhoto\n  coverVideo\n  ...InlineContentAttachmentsSectionFragment\n}\n\nfragment InlineContentHeroSectionFormFragment on Content {\n  ...InlineContentCoverVideoFormFragment\n}\n\nfragment InlineContentHeroSectionFragment on Content {\n  ...InlineContentHeroSectionStaticFragment\n  ...InlineContentHeroSectionFormFragment\n}\n\nfragment InlineContentHeroSectionStaticFragment on Content {\n  id\n  coverPhoto\n  coverVideo\n  coverVideoAsset {\n    id\n  }\n  coverVideoAssetUsage {\n    id\n  }\n}\n\nfragment LearnModeSwitchFragment on Product {\n  id\n  name\n  status\n  viewerMembership {\n    id\n  }\n}\n\nfragment QuizEditorBanner_ContentUsageFragment on ContentUsage {\n  id\n  content {\n    type\n    webForm {\n      id\n      currentRevision {\n        id\n      }\n    }\n    id\n  }\n  module {\n    isCurriculumModule\n    id\n  }\n  ...usePermissionsFragment\n}\n\nfragment QuizSubmissionEditorContentUsageFragment on ContentUsage {\n  id\n  content {\n    name\n    id\n  }\n  ...QuizSubmissionFormContentUsageFragment\n}\n\nfragment QuizSubmissionFormContentUsageFragment on ContentUsage {\n  confirmationModalContent {\n    ...CurriculumConfirmationModalConfirmationModalFragment\n    id\n  }\n}\n\nfragment ShareContentUsageByEmailButtonFragment on ContentUsage {\n  id\n  entity\n  module {\n    id\n  }\n  content {\n    label\n    id\n  }\n}\n\nfragment ShareContentUsageUtils_useShareUrlFragment on ContentUsage {\n  id\n  entity\n  ...ContentUsageUtils_useContentUsagePathContentUsageFragment\n}\n\nfragment SubmitAssignmentFormFieldsFragment on ContentUsage {\n  id\n  submissionVisibility\n  submissionFormat {\n    text {\n      enabled\n      required\n    }\n    file {\n      enabled\n      required\n    }\n    link {\n      enabled\n      required\n    }\n  }\n}\n\nfragment SubmitAssignmentFormFragment on ContentUsage {\n  id\n  dueAt\n  submissionVisibility\n  ...SubmitAssignmentFormFieldsFragment\n  ...ContentUsageUtils_useSubmissionDeadlineFragment\n  confirmationModalContent {\n    ...CurriculumConfirmationModalConfirmationModalFragment\n    id\n  }\n  ...usePermissionsFragment\n}\n\nfragment UpdateContentModuleButtonFragment on ContentUsage {\n  id\n  entity\n  entityId\n  content {\n    type\n    label\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n\nfragment useTrackContentCompletionFragment on ContentUsage {\n  id\n  entity\n  content {\n    type\n    label\n    id\n  }\n}\n\nfragment useTrackContentViewFragment on ContentUsage {\n  id\n}\n"
  }
};
})();

(node as any).hash = "685fe118e80f8377dd77b4698a647b42";

export default node;
